import {inject, Injectable} from "@angular/core"
import {TiledImageManager} from "@cm/browser-utils"
import {CM_LOGGER_TEXTURES} from "@common/services/logging"

@Injectable({
    providedIn: "root",
})
export class TiledImageManagerService extends TiledImageManager {
    constructor() {
        super(inject(CM_LOGGER_TEXTURES))
    }
}
